import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row py-4" }
const _hoisted_2 = { class: "w-13/20 px-6 space-y-6" }
const _hoisted_3 = { class: "w-7/20 border-l border-gray-400 px-6" }
const _hoisted_4 = { class: "flex flex-row justify-end items-center space-x-4 py-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalForm, {
      title: _ctx.$t('posFavourite.defaultDiscountSettings.title'),
      onClose: _ctx.onCloseUpdate,
      modalWidth: "w-2/5",
      isFooter: false,
      isScroll: false
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('posFavourite.defaultDiscountSettings.discount'),
              class: "col-span-2 w-1/2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  "data-testid": "pos-favorite-default-discount-input",
                  modelValue: _ctx.dataDetail.defaultDiscount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataDetail.defaultDiscount = $event)),
                  format: _ctx.formatDefaultDiscount,
                  suffix: "%",
                  error: _ctx.parsedDefaultDisount > 25,
                  errorCaption: _ctx.$t('posFavourite.defaultDiscountSettings.maxDiscount'),
                  errorIcon: false
                }, null, 8, ["modelValue", "format", "error", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('posFavourite.defaultDiscountSettings.lastUpdated'),
              value: _ctx.getUpdatedBy,
              caption: _ctx.dataDetail.updatedBy
            }, null, 8, ["label", "value", "caption"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseUpdate,
            customClass: "px-10 py-2",
            textColor: "red-lp-300",
            title: _ctx.$t('posFavourite.defaultDiscountSettings.cancel'),
            outline: ""
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            "data-testid": "pos-favorite-default-discount-button-save",
            disabled: _ctx.isDisabled,
            onClick: _ctx.onConfirm,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('posFavourite.defaultDiscountSettings.save')
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]), [
      [_vShow, _ctx.modelValue]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.onCloseConfirmation,
      title: _ctx.$t('posFavourite.defaultDiscountSettings.confirmTitle'),
      message: _ctx.$t('posFavourite.defaultDiscountSettings.confirmMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('posFavourite.defaultDiscountSettings.save'),
      textCancel: _ctx.$t('posFavourite.defaultDiscountSettings.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('posFavourite.defaultDiscountSettings.successTitle'),
      message: _ctx.$t('posFavourite.defaultDiscountSettings.successMessage'),
      image: "image-modal-success",
      textSuccess: _ctx.$t('posFavourite.defaultDiscountSettings.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isSuccess]
    ])
  ], 64))
}